import React from 'react';

const PenaltiesSection = () => {
  return (
    <section className="sec pen" id="penalties">
      <div className="shell">
        <div className="pen-grid">
          <div className="rv">
            <h2 className="h2">What are the penalties for filing late?</h2>
            <p className="answer">
              Late registration costs a one-off AED 10,000. Late filing costs AED 500 for every month or part month during the
              first year, then AED 1,000 a month from month thirteen. Unpaid tax accrues interest at 14% a year. One day late
              counts as a full month.
            </p>
            <div className="sources">
              <b>Sources.</b> Registration and filing penalties are set by Cabinet Decision No. 75 of 2023, as amended by
              Cabinet Decision No. 10 of 2024. The 14% late payment interest is set by Cabinet Decision No. 129 of 2025.
              Figures current at 31 July 2026. We confirm what applies to your company, and your exact deadline, on the call.
            </div>
          </div>

          <div className="pen-rows rv">
            <div className="pen-row">
              <span className="pen-fig">
                10,000<small>AED, one-off</small>
              </span>
              <span className="pen-what">
                <b>Registering late</b>Charged once for missing the Corporate Tax registration deadline for your licence.
              </span>
            </div>
            <div className="pen-row">
              <span className="pen-fig">
                500<small>AED per month</small>
              </span>
              <span className="pen-what">
                <b>Filing late, months 1 to 12</b>For each month or part month the return is outstanding.
              </span>
            </div>
            <div className="pen-row">
              <span className="pen-fig">
                1,000<small>AED per month</small>
              </span>
              <span className="pen-what">
                <b>Filing late, month 13 onward</b>The monthly charge doubles the longer it runs.
              </span>
            </div>
            <div className="pen-row">
              <span className="pen-fig">
                14%<small>per year</small>
              </span>
              <span className="pen-what">
                <b>Paying late</b>Interest on the unpaid tax, running from the day after the due date until it is settled.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PenaltiesSection;
